import { useState } from "react";
import { useNavigate } from "react-router-dom";
import style from "./SignupPage.module.css";
import SiteInfoFooter from '../components/SiteInfoFooter';

function SignupPage() {
  const navigate = useNavigate();

  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const signup = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const res = await fetch("/api/register", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username: userName, password }),
      });

      // Read error message from backend
      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.error || "Signup failed");
      }

      // success -> navigate to login
      navigate("/login");
    } catch (err) {
      console.error(err);
      setError(err.message); // show exact backend error
    }
  };

  return (
    <>
      <div className={style.signupContainer}>
        <div className={style.signupCard}>
          <h1>Create Account</h1>
          <p>Sign up to get started</p>

          <form onSubmit={signup}>
            <div className={style.inputGroup}>
              <label>User Name</label>
              <input
                type="text"
                required
                value={userName}
                onChange={(e) => setUserName(e.target.value)}
              />
            </div>

            <div className={style.inputGroup}>
              <label>Password</label>
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>

            {error && <p className={style.errorText}>{error}</p>}

            <button className={style.signupButton} type="submit">
              Sign Up
            </button>
          </form>

          <p className={style.footerText}>
            Already have an account?{" "}
            <span onClick={() => navigate("/login")}>Sign in</span>
          </p>

        </div>
      </div>
      <SiteInfoFooter />
    </>
  );
}

export default SignupPage;
